export const horairesData = [
  { day: "Lundi", hours: ["Fermé"] },
  { day: "Mardi", hours: ["11h30 – 14h00", "18h00 – 21h30"] },
  { day: "Mercredi", hours: ["11h30 – 14h00", "18h00 – 21h30"] },
  { day: "Jeudi", hours: ["11h30 – 14h00", "18h00 – 21h30"] },
  { day: "Vendredi", hours: ["11h30 – 14h00", "17h00 – 21h30"] },
  { day: "Samedi", hours: ["11h30 – 14h00", "17h00 – 21h30"] },
  { day: "Dimanche", hours: ["Fermé"] }
];